import { Injectable, Injector, SecurityContext } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpClient
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, retryWhen } from 'rxjs/operators';
import { ErrorHandlerConstants } from '../../../models/const.WebApiBusinessExceptionHandler';
import { AlertService } from '../Alerts/alert.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../src/environments/environment'
interface EnvironmentType {
  type: string;
  url: string;
  redirect: string;
  loginPage: string;
}

@Injectable({ providedIn:"root" })
export class HttpErrorHandler implements HttpInterceptor {
  
  constructor(private alertService: AlertService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private http: HttpClient) {
  }


  private sanitizeUrl(url): string {
    return this.sanitizer.sanitize(SecurityContext.URL, url)
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
          } else if (error.status >= 401 && error.status < 402) {
            const location = error.headers.get("location");
            const urlLocation: Location = window.location;
            const origin = urlLocation.origin;
            const port = urlLocation.port;
            const env = this.isEnvironment(origin);
            if ( env != undefined && env!=null) {
              this.doRedirect(error, location,env);
              errorMessage = "Redirecionado";
            }

          
          }
          // PIT 40802 
          else if (error.error && error.error.errorCode == "E") {
            errorMessage = error.error.errorMessage;
          } else if (error.message.includes("ValidaDisponibilidade")) {
            //router para a página de indisponibilidade da PGP
            this.router.navigate(['validatepgponline']);
          }
          
          else if (error.status >= 403 && error.status < 404) {
            // deu erro 403 mas não sabemos se é por causa da ValidaDisponibilidade
            this.testaValidaDisponibilidade(); 
            errorMessage = 'Não tem autorização para executar esta ação.';
          }
          else if (error.status === ErrorHandlerConstants.webApiBusinessExceptionStatusCode) {
            const webApiError = error.error as models.WebApiBusinessExceptionVM;
            errorMessage = webApiError.errorMessage || webApiError.errorCode;
          }
          else if (error.status == 401) {
            console.log(`${error.message}`);
            errorMessage = 'A sua sessão expirou. Por favor faça de novo login.';
          }
          else if (error.status == 500 && error.error && error.error?.toString().includes("User not authenticaded with NSI!")) { // Testa se é um erro de autenticação do NSI, se for, redireciona para a página de login
            console.log(`${error.error}`);
            
            // Redirect para a página de login do NSI
            const location = error.headers.get("location");
            const urlLocation: Location = window.location;
            const origin = urlLocation.origin;
            const port = urlLocation.port;
            const env = this.isEnvironment(origin);
            if (env != undefined && env != null) {
              this.doRedirect(error, location, env);
              errorMessage = "Redirecionado";
            }
            
          } 
          else {
            error.message.includes("")
            const errorDate = new Date();
            console.log(`${error.message}`);
            console.log(`${error.error?.message}a`);
            errorMessage = `Ocorreu um erro inesperado. Por favor, tente mais tarde ou contacte-nos através dos meios alternativos. Informação adicional : Código de erro : ${error.status} | Data : ${errorDate.toLocaleString('pt-PT')} `
            //errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
          }

          this.alertService.error(errorMessage)
          return throwError(errorMessage);
        })
      )
  }


  testaValidaDisponibilidade() {
    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall')
      .subscribe((result: any) => {

      if (result.stateCode == 'I') {
        // router ValidaDisponibidade
        this.router.navigate(['validatepgponline']);
        return;
      }
    });
  }


  isEnvironment(host: string): EnvironmentType {
    let result = environment.allowedOrigins.find(env => {
      return host.includes(env.url);
    });
    return result;
  }

  doRedirect(error: HttpErrorResponse, location: string, env: EnvironmentType) {


    console.info("Tenho unauthorized com header location. É um pedido para saltar para o autenticador externo em: ", location);
    // Se temos unauthorized com pedido de redirect é porque é uma redireção para autenticação
    // Neste caso temos que mudar a redirect_uri que foi enviada pelo servidor pois essa
    // Ia redirecionar todo o browser para a chamada de api que fizemos aqui
    // Para resolver, esmagamos esse valor com a location atual do browser de forma
    // a reposicionar o angular neste ponto da app quando terminar o login
    let url = null;
    if (location == null || location == undefined ) {
      if (env.loginPage != null) {
        url = new URL( env.url +"/"+ env.loginPage);
      } else {
        url = new URL( env.redirect);
      }
      
    } else {
      if (env.loginPage != null && env.loginPage != undefined) {
        url = new URL(location);
      } else {
        url = new URL(env.redirect);
      }
      
    }
    
    // Este parâmetro tem que estar coerente com a configuração do Startup
    url.searchParams.set("redirect_uri", this.sanitizeUrl(window.location.href));
    //url.searchParams.set("redirect_uri", window.location.href);
    console.info("Url rescrita com um redirectUrl que faz sentido para o browser, é para aqui o redirect: ", url.toString());
    window.location.href = url.toString();

    return;
  }




}
